import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-main-base',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule, MatButtonModule
  ],
  templateUrl: './main-base.component.html',
  styleUrl: './main-base.component.scss'
})
export class MainBaseComponent {
  @Input() isMobile: boolean = false;
  @Input() useGrid: boolean = true;
  @Input() fullHeight: boolean = true;
  @Output() back = new EventEmitter<void>();
}
